// removed by extract-text-webpack-plugin
module.exports = {"tag_block":"tag_block"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/TagBlock/style.scss
// module id = 1361
// module chunks = 0